export default "https://cdn-static.gokick.com/assets/b944ecdade3ab4b24738bd1fcec1eea00d00fb75/images/sleep-green-apple.f7a444510e3da94f2e4fec3a465032b1.png";